/* theme.js — interactivity for the product landing page */
(function () {
  "use strict";

  /* ---------- Image gallery ---------- */
  function initGallery() {
    var stage = document.querySelector("[data-gallery-stage]");
    var thumbs = document.querySelectorAll("[data-gallery-thumb]");
    if (!stage || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        var img = stage.querySelector("img");
        if (img && full) img.src = full;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    document.querySelectorAll("[data-accordion-head]").forEach(function (head) {
      head.addEventListener("click", function () {
        var item = head.closest(".accordion__item");
        var panel = item.querySelector(".accordion__panel");
        var open = item.classList.toggle("is-open");
        head.setAttribute("aria-expanded", open ? "true" : "false");
        panel.style.maxHeight = open ? panel.scrollHeight + "px" : null;
      });
    });
  }

  /* ---------- Package / variant selector ---------- */
  function initPackages() {
    var packages = document.querySelectorAll("[data-pkg]");
    if (!packages.length) return;
    var totalEl = document.querySelector("[data-total]");
    var variantInput = document.querySelector("[data-variant-id]");
    var stickyPrice = document.querySelector("[data-sticky-price]");

    function select(pkg) {
      packages.forEach(function (p) { p.classList.remove("is-active"); p.setAttribute("aria-checked", "false"); });
      pkg.classList.add("is-active");
      pkg.setAttribute("aria-checked", "true");
      var price = pkg.getAttribute("data-price");
      var id = pkg.getAttribute("data-variant");
      if (totalEl && price) totalEl.textContent = price;
      if (stickyPrice && price) stickyPrice.textContent = price;
      if (variantInput && id) variantInput.value = id;
    }

    packages.forEach(function (pkg) {
      pkg.addEventListener("click", function () { select(pkg); });
      pkg.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(pkg); }
      });
    });
    var active = document.querySelector("[data-pkg].is-active") || packages[0];
    if (active) select(active);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCart() {
    document.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var variantInput = document.querySelector("[data-variant-id]");
        var id = variantInput ? variantInput.value : btn.getAttribute("data-variant");
        if (!id) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = "Adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = "Added ✓";
            updateCartCount();
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);
          })
          .catch(function () {
            btn.textContent = "Try again";
            btn.disabled = false;
          });
      });
    });
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "grid" : "none";
        });
      })
      .catch(function () {});
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var drawer = document.querySelector("[data-nav-drawer]");
    if (!toggle || !drawer) return;
    toggle.addEventListener("click", function () {
      var open = drawer.hasAttribute("hidden");
      if (open) drawer.removeAttribute("hidden"); else drawer.setAttribute("hidden", "");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initGallery();
    initAccordion();
    initPackages();
    initAddToCart();
    initMobileNav();
    updateCartCount();
  });
})();
